import React from 'react';

/**
 * DockIcons - High-Contrast Phosphor Terminal Aesthetic
 * Solid-Fill, geometric silhouettes with HUD styling.
 * Color: #FFFFFF (Neon Green)
 */

const DockIcons = {
  about: (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Solid User Silhouette */}
      <circle cx="24" cy="16" r="8" fill="#FFFFFF" />
      <path d="M 8 40 C 8 30 16 26 24 26 C 32 26 40 30 40 40 V 44 H 8 V 40 Z" fill="#FFFFFF" />
    </svg>
  ),

  projects: (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Solid Rocket/Launch Silhouette */}
      <path d="M 24 4 L 29 16 H 38 L 31 22 L 34 34 L 24 28 L 14 34 L 17 22 L 10 16 H 19 L 24 4 Z" fill="#FFFFFF" />
      <path d="M 24 32 V 44" stroke="#FFFFFF" strokeWidth="4" />
    </svg>
  ),

  terminal: (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Solid Terminal Block with Cutout Prompt */}
      <path fillRule="evenodd" clipRule="evenodd" d="M 4 8 C 4 5.79086 5.79086 4 8 4 H 40 C 42.2091 4 44 5.79086 44 8 V 40 C 44 42.2091 42.2091 44 40 44 H 8 C 5.79086 44 4 42.2091 4 40 V 8 Z M 14 16 L 22 24 L 14 32 H 18 L 26 24 L 18 16 H 14 Z M 28 32 H 36 V 28 H 28 V 32 Z" fill="#FFFFFF" />
    </svg>
  ),

  filemanager: (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Heavy Solid Tabbed Folder */}
      <path d="M 4 10 C 4 7.79086 5.79086 6 8 6 H 20 L 24 10 H 40 C 42.2091 10 44 11.7909 44 14 V 38 C 44 40.2091 42.2091 42 40 42 H 8 C 5.79086 42 4 40.2091 4 38 V 10 Z" fill="#FFFFFF" />
    </svg>
  ),

  notes: (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Solid Sticky Note */}
      <path d="M 8 4 H 32 L 42 14 V 44 H 8 V 4 Z M 32 4 V 14 H 42" fill="#FFFFFF" fillRule="evenodd" />
    </svg>
  ),

  cyberchef: (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Solid Gear/Tool */}
      <path d="M 24 44 C 35.0457 44 44 35.0457 44 24 C 44 12.9543 35.0457 4 24 4 C 12.9543 4 4 12.9543 4 24 C 4 35.0457 12.9543 44 24 44 Z M 24 34 C 29.5228 34 34 29.5228 34 24 C 34 18.4772 29.5228 14 24 14 C 18.4772 14 14 18.4772 14 24 C 14 29.5228 18.4772 34 24 34 Z" fill="#FFFFFF" fillRule="evenodd" />
    </svg>
  ),

  taskmanager: (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Solid Chart Blocks */}
      <rect x="6" y="24" width="8" height="20" rx="1" fill="#FFFFFF" />
      <rect x="20" y="14" width="8" height="30" rx="1" fill="#FFFFFF" />
      <rect x="34" y="30" width="8" height="14" rx="1" fill="#FFFFFF" />
      {/* Pulse Line Top */}
      <path d="M 4 14 H 14 L 18 6 L 24 18 L 30 10 L 34 14 H 44" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),

  root: (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Bold Red Shield for Warning/Root */}
      <path d="M 24 4 L 6 12 V 22 C 6 33.3 13.8 44.1 24 47 C 34.2 44.1 42 33.3 42 22 V 12 L 24 4 Z M 24 34 C 20 34 16.5 31 16 27 H 32 C 31.5 31 28 34 24 34 Z M 24 12 C 26.2 12 28 13.8 28 16 C 28 18.2 26.2 20 24 20 C 21.8 20 20 18.2 20 16 C 20 13.8 21.8 12 24 12 Z" fill="#ff4444" />
    </svg>
  ),

  contact: (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Solid Envelope */}
      <path d="M 4 10 C 4 7.79 5.79 6 8 6 H 40 C 42.21 6 44 7.79 44 10 V 38 C 44 40.21 42.21 42 40 42 H 8 C 5.79 42 4 40.21 4 38 V 10 Z M 24 26 L 8 12 H 40 L 24 26 Z" fill="#FFFFFF" fillRule="evenodd" />
    </svg>
  ),

  resume: (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Solid Document with Line Cutouts */}
      <path fillRule="evenodd" clipRule="evenodd" d="M 8 6 C 8 3.79086 9.79086 2 12 2 H 36 C 38.2091 2 40 3.79086 40 6 V 42 C 40 44.2091 38.2091 46 36 46 H 12 C 9.79086 46 8 44.2091 8 42 V 6 Z M 16 16 H 32 V 12 H 16 V 16 Z M 16 24 H 32 V 20 H 16 V 24 Z M 16 32 H 26 V 28 H 16 V 32 Z" fill="#FFFFFF" />
    </svg>
  ),

  trash: (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Solid Trash Bin */}
      <path d="M 10 10 H 38 V 40 C 38 42.2 36.2 44 34 44 H 14 C 11.8 44 10 42.2 10 40 V 10 Z" fill="#FFFFFF" />
      <path d="M 16 4 H 32 V 8 H 40 V 12 H 8 V 8 H 16 V 4 Z" fill="#FFFFFF" />
    </svg>
  ),
};

export default DockIcons;

